/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e292537ad45acb6cc3aae4281fbfa6060b6cc28c";
